// extracted by mini-css-extract-plugin
export var boxItems = "_1h-1";
export var button = "_1h-5";
export var filterGroupBox = "_1h-0";
export var icon = "_1h-2";
export var iconSecondary = "_1h-4";
export var iconWrapper = "_1h-3";